import listTemplate from './list/list.template.html?raw';
import dashboardTemplate from './dashboard/dashboard.template.html?raw';
import navigationTemplate from './common/templates/navigation.template.html?raw';
import descriptionTemplate from './common/templates/introduction/description.template.html?raw';
import articlesTemplate from './common/templates/introduction/articles.template.html?raw';
import sdgTemplate from './common/templates/introduction/sdg.template.html?raw';
import companiesTemplate from './common/templates/ground/companies.template.html?raw';
import consultantsTemplate from './common/templates/ground/consultants.template.html?raw';
import jobsTemplate from './common/templates/ground/jobs.template.html?raw';
import sectorsChartTemplate from './common/templates/funding/sectors_chart.template.html?raw';
import donorsChartTemplate from './common/templates/funding/donors_chart.template.html?raw';
import contractsTemplate from './common/templates/funding/contracts.template.html?raw';
import programsTemplate from './common/templates/funding/programs.template.html?raw';
import fundingInfosTemplate from './common/templates/funding/funding_infos.template.html?raw';

angular
  .module('countriesApp')
  .run([
    '$templateCache',
    function($templateCache) {
      $templateCache.put(listTemplate, listTemplate);
      $templateCache.put(dashboardTemplate, dashboardTemplate);
      $templateCache.put(navigationTemplate, navigationTemplate);
      $templateCache.put(descriptionTemplate, descriptionTemplate);
      $templateCache.put(articlesTemplate, articlesTemplate);
      $templateCache.put(sdgTemplate, sdgTemplate);
      $templateCache.put(companiesTemplate, companiesTemplate);
      $templateCache.put(consultantsTemplate, consultantsTemplate);
      $templateCache.put(jobsTemplate, jobsTemplate);
      $templateCache.put(sectorsChartTemplate, sectorsChartTemplate);
      $templateCache.put(donorsChartTemplate, donorsChartTemplate);
      $templateCache.put(contractsTemplate, contractsTemplate);
      $templateCache.put(programsTemplate, programsTemplate);
      $templateCache.put(fundingInfosTemplate, fundingInfosTemplate);
    }
  ]);

angular
  .module('countriesApp')
  .config([
    '$locationProvider',
    '$stateProvider',
    '$urlMatcherFactoryProvider',
    '$urlRouterProvider',
    (
      $locationProvider,
      $stateProvider,
      $urlMatcherFactoryProvider,
      $urlRouterProvider
    ) => {
      // This allows for use of regular URL path and search segments, instead of
      // their hashbang equivalents. If the HTML5 History API is not supported
      // by browser, $location service falls back to using hashbang URLs
      $locationProvider.html5Mode(true);

      // Allow trailing slash in URL so that `/countries/` will still send user
      // to the countries index page, instead of treating the trailing slash
      // as a slug_and_id param, that would evaluate to null
      // `/countries/zambia-1195/` will resolve to `/countries/zambia-1195`
      $urlMatcherFactoryProvider.strictMode(false);

      $urlRouterProvider.otherwise('/countries');

      // Function (and dependencies) that resolve the country from the slug_and_id (if any)
      const countryResolver = [
        '$rootScope',
        '$state',
        '$stateParams',
        'CountryService',
        function ($rootScope, $state, $stateParams, Country) {
          return Country.getBySlugAndId($stateParams.slug_and_id)
            .then(country => {
              if(!country) {
                $state.go('list');
              }

              $rootScope.$emit('updateTitle', country);

              return country;
            });
        }
      ];

      // Before resolving state and instantiating the Main and Edit controller,
      // make sure $stateParams.slug_and_id in URL is a valid country. The
      // CountryService will take care of that. If it's a valid one, it will go
      // on with GET request. If not, promise is rejected, throws error and we
      // redirect user to List state.
      $stateProvider
        .state('list', {
          url: '/countries',
          templateUrl: listTemplate,
          controller: 'ListController'
        })
        .state('main', {
          templateUrl: dashboardTemplate,
          controller: 'DashboardController',
          resolve: {
            resolvedCountry: countryResolver
          }
        })
        .state('dashboard', {
          url: '/countries/:slug_and_id',
          parent: 'main',
          views: {
            'navigation@main': {
              templateUrl: navigationTemplate
            },
            'description@main': {
              templateUrl: descriptionTemplate
            },
            'articles@main': {
              templateUrl: articlesTemplate
            },
            'sdg@main': {
              templateUrl: sdgTemplate,
            },
            'companies@main': {
              templateUrl: companiesTemplate
            },
            'consultants@main': {
              templateUrl: consultantsTemplate
            },
            'jobs@main': {
              templateUrl: jobsTemplate
            },
            'sectors_chart@main': {
              templateUrl: sectorsChartTemplate
            },
            'donors_chart@main': {
              templateUrl: donorsChartTemplate
            },
            'contracts@main': {
              templateUrl: contractsTemplate
            },
            'programs@main': {
              templateUrl: programsTemplate
            },
            'funding_infos@main': {
              templateUrl: fundingInfosTemplate
            }
          }
        });
    }]);
